/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Build_Dose_TitleInputs */

const en_us2_plan_build_dose_title = /** @type {(inputs: Plan_Build_Dose_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sets and reps`)
};

const pt_br2_plan_build_dose_title = /** @type {(inputs: Plan_Build_Dose_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Séries e repetições`)
};

const es_419_plan_build_dose_title = /** @type {(inputs: Plan_Build_Dose_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Series y repeticiones`)
};

const pt_pt2_plan_build_dose_title = /** @type {(inputs: Plan_Build_Dose_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Séries e repetições`)
};

const fr_fr2_plan_build_dose_title = /** @type {(inputs: Plan_Build_Dose_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Séries et répétitions`)
};

const de_de2_plan_build_dose_title = /** @type {(inputs: Plan_Build_Dose_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sätze und Wiederholungen`)
};

const it_it2_plan_build_dose_title = /** @type {(inputs: Plan_Build_Dose_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Serie e ripetizioni`)
};

/**
* | output |
* | --- |
* | "Sets and reps" |
*
* @param {Plan_Build_Dose_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_build_dose_title = /** @type {((inputs?: Plan_Build_Dose_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Build_Dose_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_build_dose_title(inputs)
	if (locale === "es-419") return es_419_plan_build_dose_title(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_build_dose_title(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_build_dose_title(inputs)
	if (locale === "de-DE") return de_de2_plan_build_dose_title(inputs)
	if (locale === "it-IT") return it_it2_plan_build_dose_title(inputs)
	return en_us2_plan_build_dose_title(inputs)
});
export { plan_build_dose_title as "plan-build.dose_title" }